// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsvg[data-v-229c6e1a] {\r\n  display: inline-block;\r\n  vertical-align: baseline;\r\n  margin-bottom: -2px; /* yes, I'm that particular about formatting */\n}\r\n", ""]);
// Exports
module.exports = exports;
